import * as styles from './trackStyles'
import isEmpty from 'lodash.isempty'
import Link from 'next/link'
import { authSelectors } from 'store/auth'
import { EntriesList } from './EntriesList'
import { fetchNextPage } from 'services/actions/entryActions'
import { Fragment, useRef } from 'react'
import { Layout } from 'components/Layout'
import { Loading } from 'components/Loading'
import { logEntriesSelectors } from 'store/logEntries'
import { NewEntry } from '../shared/NewEntry'
import { PageLoader } from 'components/Loading'
import { SampleEntriesGroup } from './SampleEntriesGroup'
import { Tutorial } from 'components/Tutorial'
import { useEntries } from 'hooks/useEntries'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'
import { useOdoSelector } from 'store/store'
import { useSelector } from 'react-redux'
import { useTags } from 'hooks/useTags'

const NextPageLoader = () => {
  const ref = useRef()

  const isLoading = useOdoSelector(logEntriesSelectors.isLoading)
  const endReached = useOdoSelector(logEntriesSelectors.endReached)

  const canLoadMore = !isLoading && !endReached

  useIntersectionObserver(ref, () => {
    if (canLoadMore) fetchNextPage()
  })

  if (endReached) return null

  return (
    <Fragment>
      {isLoading ? (
        <Loading
          text="Loading more entries..."
          className={styles.loadMoreTrigger()}
        />
      ) : (
        <div
          id="load-more-entries"
          ref={ref}
          className={styles.loadMoreTrigger()}
        />
      )}
    </Fragment>
  )
}

export const Track = () => {
  const { isLoading: tagsLoading } = useTags()
  const { isLoading: entriesLoading } = useEntries()

  const profile = useSelector(authSelectors.profile)
  const entriesGroupedByDay = useOdoSelector(logEntriesSelectors.groupedByDay)

  const initialLoading = tagsLoading || entriesLoading
  const noEntries = !entriesLoading && isEmpty(entriesGroupedByDay)

  if (initialLoading) {
    return (
      <Layout>
        <PageLoader />
      </Layout>
    )
  }

  return (
    <Layout>
      <div className={styles.entriesContainer()}>
        <NewEntry />

        {noEntries && (
          <Tutorial.Dismissable
            item="track"
            css={{ marginBottom: '$sizes$spacerYS' }}
          >
            <Tutorial.Bubble>
              Hi {profile?.name}, welcome to Odo!
            </Tutorial.Bubble>

            <Tutorial.Bubble>
              A tool to record your journey: Odo uses a simple start/stop timer
              and colourful tags to create entries. Later, you&apos;ll use these
              tags to calculate time spent on a project, log billable hours,
              measure progress, and more! To get you started, we&apos;ve shared
              some sample entries below and a quick tutorial video. If
              you&apos;d rather watch later, you can view the tutorial at any
              time via Menu &gt; Account.
            </Tutorial.Bubble>

            <Tutorial.Action
              as={Link}
              // @ts-expect-error
              href="/guide/tutorials"
              variant="secondary"
            >
              Quick tutorial
            </Tutorial.Action>
          </Tutorial.Dismissable>
        )}

        <SampleEntriesGroup />

        <EntriesList entriesGroup={entriesGroupedByDay} />

        <NextPageLoader />
      </div>
    </Layout>
  )
}
